import {useTranslation} from '@/translations/i18n.tsx'
import {ModalBody, ModalCloseButton, ModalHeader, ModalHeaderTitle} from '@components/ui/modal-atoms'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'
import {FC} from 'react'
import {AirbnbSSOWidget} from '@features/user/components/airbnb-sso-widget'
import {routes} from '@utilities/constants/routes'
import introImage from '@/assets/introImage.png'

interface ChangeAccountModalProps {
    onClose: () => void
}

export const ChangeAccountModal: FC<ChangeAccountModalProps> = ({onClose}) => {
    const {t} = useTranslation()
    const redirectUrl = `${routes.SETTINGS.handle.fullPath}?isConfirmAccount=true`

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent
                className="w-[510px] h-[670px] grid grid-rows-[auto_1fr] overflow-hidden"
                showCloseButton={false}
            >
                <ModalHeader className="grid grid-cols-[32px_1fr_32px] items-center justify-center border-none">
                    <DialogClose data-slot="dialog-close" render={<ModalCloseButton />} />
                    <ModalHeaderTitle className="p-0">{t('settings:link_airbnb_account:title')}</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody className="h-auto">
                    <AirbnbSSOWidget
                        redirectUrl={redirectUrl}
                        title={t('link_airbnb_account:title')}
                        description={t('link_airbnb_account:description')}
                        image={introImage}
                    />
                </ModalBody>
            </DialogContent>
        </Dialog>
    )
}
